(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    // Global video-autoplay.js handles all autoplay logic
  // This file ensures webkit-playsinline is set via the data attribute
  document.addEventListener('DOMContentLoaded', function () {
    const videos = document.querySelectorAll('deferred-media video[autoplay], video.autoplay[data-video-type]');
    videos.forEach(function(video) {
      video.setAttribute('webkit-playsinline', '');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
